import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Standard padded container for content pages. */
export function PageContainer({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <div className={cn('mx-auto max-w-7xl px-6 py-8', className)}>{children}</div>
}
